var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.isActive
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Add Alias ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-form",
              {
                staticClass: "pt-2",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                    return _vm.create($event)
                  }
                }
              },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("gg-text-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            outlined: "",
                            dense: "",
                            label: "Alias Name",
                            placeholder: "ex. sales",
                            autocomplete: "off",
                            name: "Alias",
                            "error-messages": _vm.errors.collect("Alias")
                          },
                          model: {
                            value: _vm.model.alias,
                            callback: function callback($$v) {
                              _vm.$set(_vm.model, "alias", $$v)
                            },
                            expression: "model.alias"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("gg-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            label: "Domain",
                            items: _vm.domains,
                            loading: _vm.loading,
                            disabled: _vm.loading,
                            "data-vv-name": "domain",
                            "data-vv-as": "Domain",
                            "error-messages": _vm.errors.collect("domain")
                          },
                          model: {
                            value: _vm.model.domain,
                            callback: function callback($$v) {
                              _vm.$set(_vm.model, "domain", $$v)
                            },
                            expression: "model.domain"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("gg-input-label", [_vm._v("Delivers To")]),
                        _c(
                          "p",
                          {
                            staticClass: "body-2 mb-4"
                          },
                          [_vm._v(_vm._s(_vm.mailbox.email))]
                        )
                      ],
                      1
                    ),
                    _vm.address
                      ? _c(
                          "v-col",
                          {
                            staticClass: "pt-0",
                            attrs: {
                              cols: "12"
                            }
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "body-2 mb-0"
                              },
                              [
                                _vm._v(" Mail sent to "),
                                _c("strong", [_vm._v(_vm._s(_vm.address))]),
                                _vm._v(" will be delivered to "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.mailbox.email))
                                ]),
                                _vm._v(". ")
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c("v-spacer"),
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.saving,
                  disabled: _vm.loading
                },
                on: {
                  click: _vm.create
                }
              },
              [_vm._v(" Add Alias ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }